export enum StoreKeys {
  APP_CONFIG = 'app-config',
  PROFILE = 'profile',
  DIALOGS = 'dialogs',
  APP = 'app',
  DELETE_MEK = 'delete-mek'
}
